import { gEnums } from 'global/enums/globalEnums';
import Wrapper from 'global/wrappers/Wrapper';
import _ from 'lodash';
import { useMatchSchedule } from 'projectSpecific/sports/useHelpers/useMatchSchedule';
import { useContext, useMemo, useState } from 'react';
import { _matchDisplayTypes, MatchContentWithProvider } from '../matches/MatchContent';
import MatchFilter from '../matches/MatchFilter';
import { SeasonMatchesContext } from 'projectSpecific/sports/cnr/contexts/SeasonMatchesContext';
import { SportsSeasonContext } from 'projectSpecific/sports/cnr/contexts/SportsSeasonContext';
import { ParentContext } from 'global/cnr/contexts/ParentContext';
import { useMatchScheduleOptions } from 'projectSpecific/sports/useHelpers/useMatchScheduleOptions';
import { TeamOpps } from '../teams/TeamOpps';

const oppsOnly = true

const TeamSchedule = ({
  teamKeys = [],
  matchScheduleDisplayType = gEnums.matchScheduleDisplayTypes.teamSchedule,
  parentKey = '',
  teamKey,
  fromSquares,
  matches_team,
  allowDrag,
  matches_teamSeasonal,
  matches_teamNonGs,
  matches_missAssigned,
  oc
}) => {

  const parentContext = useContext(ParentContext);
  const { states } = parentContext ?? {};
  const { paps_state } = states ?? {};
  const { pathViews } = paps_state ?? {};

  const _teamKey = teamKey || pathViews.teams

  const { _matchDisplayType: matchDisplayType, _matchDisplayOptions: matchDisplayOptions } = useMatchScheduleOptions({ matchScheduleDisplayType })

  const props = {
    teamKeys,
    matchDisplayType,
    matchScheduleDisplayType,
    teamKey: _teamKey,
    matchDisplayOptions,
  }

  // sportsSeasonContext
  const sportsSeasonContext = useContext(SportsSeasonContext);
  const { sportsSeason_state } = sportsSeasonContext ?? {};
  const { matches_info } = sportsSeason_state ?? {};
  const { matches_groupInfo } = matches_info ?? {};
  const { matches_combined } = matches_groupInfo ?? {};

  //seasonMatchesContext
  const seasonMatchesContext = useContext(SeasonMatchesContext)
  const { seasonMatches_state } = seasonMatchesContext ?? {}
  const { matchFilter } = seasonMatches_state ?? {}

  const { getScheduleMatches } = useMatchSchedule(props)

  const [showOpponents, setShowOpponents] = useState(false)

  const handleShowOpponents = (value) => setShowOpponents(value)

  const getDateChangedMatches = (matches_1, matches_2) => {

    const matchesByTeams = _.keyBy(
      matches_1,
      match => `${match.home.name}|${match.away.name}`
    );

    return _.map(_.cloneDeep(matches_2), match => {
      const key = `${match.home.name}|${match.away.name}`;
      const match1 = matchesByTeams[key];
      if (match1 && match1.startDate !== match.startDate) {
        match._startDateChanged = true;
      }
      return match;
    });
  };


  const getNonGsMatches = (matches_t, matches_nonGs) => {

    const matchesByTeams = _.keyBy(
      matches_nonGs,
      match => `${match.home}|${match.away}`
    );

    return _.map(_.cloneDeep(matches_t), match => {
      const key = `${match.home.name}|${match.away.name}`;
      const match_nonGs = matchesByTeams[key];
      if (match_nonGs) {
        match._nonGs = true;
      }
      return match;
    });
  };

  const matches = useMemo(() => {
    if (matches_team) {
      console.log('matches_team', matches_team)
      console.log('matches_seasonal', matches_teamSeasonal)
      console.log('matches_teamNonGs', matches_teamNonGs)
      const xxx = getDateChangedMatches(matches_teamSeasonal, matches_team)
      const yyy = getNonGsMatches(matches_team, matches_teamNonGs)
      console.log('yyy', yyy)
      // return matches_seasonal
      return yyy
    }
    const _matches = getScheduleMatches({ matchScheduleDisplayType, matchFilter })
    const sortedTeamMatches = _.sortBy(_matches, match => new Date(match.startDate));
    return sortedTeamMatches
  }, [matches_combined, matchScheduleDisplayType, _teamKey, matchFilter, matches_team])

  const divs_matches = _.map(matches, (match) => (
    <MatchContentWithProvider
      key={match._itemKey}
      matchKey={match._itemKey}
      match={match}
      matchDisplayType={matchDisplayType}
      parentKey={parentKey}
      teamKey={_teamKey}
      matchScheduleDisplayType={matchScheduleDisplayType}
      favTeamKey={match._favTeamKey} // 👈 pass it down if needed
      oppsOnly={oppsOnly}
      allowDrag={allowDrag}
      oc={oc}
    // match_missAssigned={matches_missAssigned?.[match?._itemKey]}
    />
  ));

  let _cn = _.kebabCase(matchScheduleDisplayType)
  _cn += ' ' + _.kebabCase(matchDisplayType)

  if (oppsOnly &&
    (matchScheduleDisplayType === gEnums.matchScheduleDisplayTypes.teamSchedule ||
      matchScheduleDisplayType === gEnums.matchScheduleDisplayTypes.teamScheduleMini ||
      matchScheduleDisplayType === gEnums.matchScheduleDisplayTypes.nextTeamMatch
    )) {
    _cn += ' to'
  }

  const content = () => {
    if (showOpponents) {
      return <TeamOpps team={{ _itemKey: teamKey }} noMid={true} />
    } else {
      switch (matchDisplayType) {
        case _matchDisplayTypes.teamMatches:
          return <div className='matches-team-wrapper'>{divs_matches}</div>
        default:
          return divs_matches
      }
    }
  }

  return <Wrapper
    header={!matches_team && matchDisplayOptions?.showMatchFilter && <MatchFilter handleShowOpponents={handleShowOpponents} showOpponents={showOpponents} />}
    content={content()}
    noMid={fromSquares ? true : false}
    css={{ container: _cn }}
  />
}

export default TeamSchedule